<div class="table-row">
	@let
	r = getDataRow();
	@if (showDate()) {
		<div>{{row().date | date: 'HH:mm'}}</div>
	}
	<div class="font-decimaBold">{{r.type.charAt(0).toUpperCase() + r.type.slice(1)}}</div>
	<div>{{(r.strength * 100).toFixed()}}%</div>

	@if (detailed()) {
		@if (r.type === 'hybrid' && r.ratio) {
			<div>{{(r.ratio['indica'])}}:{{(r.ratio['sativa'])}}</div>
		}
	}

	<div class="ml-auto">{{r.qtyMg.toFixed(2)}}mg</div>
	<div>{{r.thcMg.toFixed(2)}}mg</div>
</div>